import { STATUS_MAP } from "@/data/categories";
import type { Status } from "@/lib/types";
import { cn } from "@/lib/utils";

interface Props {
  status: Status;
  className?: string;
}

export function StatusBadge({ status, className }: Props) {
  const meta = STATUS_MAP[status];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-caption font-medium whitespace-nowrap",
        meta.bg,
        meta.color,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", meta.dot)} />
      {meta.label}
    </span>
  );
}

interface PhaseStatusBadgeProps {
  status: "complete" | "active" | "upcoming";
  className?: string;
}

export function PhaseStatusBadge({ status, className }: PhaseStatusBadgeProps) {
  const map = {
    complete: { label: "Complete", cls: "bg-emerald-50 text-emerald-700", dot: "bg-emerald-500" },
    active: { label: "Active", cls: "bg-sky-50 text-sky-700", dot: "bg-sky-500" },
    upcoming: { label: "Upcoming", cls: "bg-slate-100 text-slate-600", dot: "bg-slate-400" },
  } as const;
  const meta = map[status];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-caption font-medium whitespace-nowrap",
        meta.cls,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", meta.dot)} />
      {meta.label}
    </span>
  );
}
